import * as THREE from 'three';

export const cleanAtlasRegionName = (regionName = '') => (
    String(regionName || '')
        .replace(/^ctx-[lr]h-/i, '')
        .replace(/^Right\s+/i, 'R ')
        .replace(/^Left\s+/i, 'L ')
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/_/g, ' ')
        .trim()
);


export const REGION_LABEL_GROUP_NAME = '__ATLAS_REGION_LABELS__';


export const MAX_ATLAS_REGION_LABELS = 18;


export const selectAtlasRegionLabels = (regions = []) => (
    regions
        .filter(region => region?.position && region.name && !region.name.toLowerCase().includes('unknown'))
        .filter(region => !region.name.toLowerCase().includes('corpuscallosum'))
        .sort((a, b) => b.count - a.count)
        .slice(0, MAX_ATLAS_REGION_LABELS)
);


export const createAtlasRegionLabelTexture = (BrainBrowserTHREE, label) => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const fontSize = 24;
    const text = String(label || '').replace(/\s+/g, ' ').trim();
    context.font = `700 ${fontSize}px Inter, Arial, sans-serif`;
    const textWidth = Math.ceil(context.measureText(text).width);
    const width = Math.min(420, Math.max(96, textWidth + 42));
    const height = 48;
    const radius = 18;

    canvas.width = width;
    canvas.height = height;
    context.font = `700 ${fontSize}px Inter, Arial, sans-serif`;
    context.textBaseline = 'middle';

    context.beginPath();
    context.moveTo(radius, 4);
    context.lineTo(width - radius, 4);
    context.quadraticCurveTo(width - 4, 4, width - 4, radius);
    context.lineTo(width - 4, height - radius);
    context.quadraticCurveTo(width - 4, height - 4, width - radius, height - 4);
    context.lineTo(radius, height - 4);
    context.quadraticCurveTo(4, height - 4, 4, height - radius);
    context.lineTo(4, radius);
    context.quadraticCurveTo(4, 4, radius, 4);
    context.closePath();
    context.fillStyle = 'rgba(5, 10, 24, 0.82)';
    context.fill();
    context.strokeStyle = 'rgba(148, 163, 184, 0.7)';
    context.lineWidth = 2;
    context.stroke();

    context.beginPath();
    context.arc(22, height / 2, 6, 0, Math.PI * 2);
    context.fillStyle = '#38bdf8';
    context.fill();
    context.strokeStyle = 'rgba(224, 242, 254, 0.95)';
    context.lineWidth = 2;
    context.stroke();

    context.fillStyle = '#f8fafc';
    context.fillText(text, 36, height / 2 + 1, width - 48);

    const texture = new BrainBrowserTHREE.Texture(canvas);
    texture.needsUpdate = true;
    return { texture, width, height };
};


export const clearAtlasRegionLabelSprites = (viewer) => {
    if (!viewer?.model) return;
    const existing = viewer.model.getObjectByName?.(REGION_LABEL_GROUP_NAME);
    if (existing) {
        existing.traverse?.((child) => {
            child.material?.map?.dispose?.();
            child.material?.dispose?.();
        });
        viewer.model.remove(existing);
    }
};


export const addAtlasRegionLabelSprites = (viewer, regions) => {
    if (!viewer?.model || !regions.length) return;
    const BrainBrowserTHREE = window.BrainBrowser?.SurfaceViewer?.THREE || THREE;
    const group = new BrainBrowserTHREE.Object3D();
    group.name = REGION_LABEL_GROUP_NAME;

    regions.forEach((region) => {
        const { texture, width, height } = createAtlasRegionLabelTexture(BrainBrowserTHREE, region.name);
        const material = new BrainBrowserTHREE.SpriteMaterial({
            map: texture,
            transparent: true,
            depthTest: true,
            depthWrite: false
        });
        const sprite = new BrainBrowserTHREE.Sprite(material);
        sprite.name = `${REGION_LABEL_GROUP_NAME}_${region.id}`;
        sprite.position.copy(region.position);
        sprite.scale.set(width * 0.035, height * 0.035, 1);
        group.add(sprite);
    });

    viewer.model.add(group);
};
